import { Grid, Button, Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';

// Profile Actions Component
type ProfileActionsProps = {
  subscriptionId?: string;
  annualLocked?: boolean;
  autoRenew?: boolean;
  onChangeSubscription: () => void;
  onCancelSubscription: () => void;
  onDeleteUser: () => void;
};

const ProfileActions = ({
  subscriptionId,
  annualLocked = false,
  autoRenew = true,
  onChangeSubscription,
  onCancelSubscription,
  onDeleteUser,
}: ProfileActionsProps) => {
  return (
    <Grid container rowSpacing={2} columnSpacing={2} id="profile-info-section-actions">
      <Button
        variant="contained"
        size="small"
        sx={{ bgcolor: 'white', color: 'primary.main' }}
        onClick={onDeleteUser}
      >
        <FormattedMessage id="myProfile.deleteProfile" defaultMessage="Smazat profil" />
      </Button>
      <Button
        variant="contained"
        size="small"
        sx={{ bgcolor: 'white', color: 'primary.main' }}
        onClick={onChangeSubscription}
        disabled={annualLocked}
      >
        <FormattedMessage id="myProfile.changeSubscription" defaultMessage="Změnit předplatné" />
      </Button>
      {subscriptionId && (
        <Button
          variant="contained"
          size="small"
          sx={{ bgcolor: 'white', color: 'primary.main' }}
          onClick={onCancelSubscription}
          disabled={annualLocked && !autoRenew}
        >
          {annualLocked ? (
            autoRenew ? (
              'Vypnout roční obnovení'
            ) : (
              'Roční obnovení vypnuto'
            )
          ) : (
            <FormattedMessage
              id="myProfile.cancelSubscription"
              defaultMessage="Ukončit předplatné"
            />
          )}
        </Button>
      )}
      {annualLocked && (
        <Alert severity="warning">
          Roční Expert zůstává aktivní do konce zaplaceného období. Během roku jej nelze ukončit ani
          změnit na PRO.
        </Alert>
      )}
    </Grid>
  );
};
export default ProfileActions;
